/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

// @mui material components
import "rc-tree/assets/index.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { find } from "lodash";
import moment from "moment";
import { getMedicos } from "store/catalogos/catalogosActions";

function formCita({ props, onChangeCita }) {
  const { solicitudes } = useSelector((state) => state.solicitud);
  const { medicos, hospitales } = useSelector((state) => state.catalogos);

  const dispatch = useDispatch();
  useEffect(() => {
    const idAureaLab = find(hospitales, { hospital: "Aurea Lab" })?.idHospital || 11;
    getMedicos(dispatch, idAureaLab);
  }, []);

  const { fechaCita, horaCita, idMedico, observaciones, idSolicitud } = props;

  return (
    <>
      <Autocomplete
        id="controlled-demo"
        options={solicitudes}
        getOptionLabel={(option) => option.precandidato}
        value={find(solicitudes, (opt) => opt.idSolicitud === idSolicitud) || null}
        onChange={(event, newValue) => {
          if (newValue != null) {
            if (newValue != null) {
              onChangeCita(newValue.idSolicitud, "idSolicitud");
            }
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Paciente" variant="outlined" error={false} />
        )}
        style={{ width: "100%", marginBottom: "1rem" }}
        size="small"
      />
      <TextField
        value={fechaCita}
        onChange={(event) => {
          onChangeCita(event.target.value, "fechaCita");
        }}
        error={false}
        helperText={""}
        onBlur={() => {}}
        variant="outlined"
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        style={{ width: "100%", marginBottom: "1.5rem", cursor: "pointer" }}
        size="small"
        type="date"
        autoComplete="off"
        inputProps={
          {
            //min: moment().format("YYYY-MM-DD"),
          }
        }
        onClick={(e) => e.target.showPicker && e.target.showPicker()}
      />
      <TextField
        type="time"
        value={horaCita}
        onChange={(event) => {
          onChangeCita(event.target.value, "horaCita");
        }}
        label={"Hora"}
        variant="outlined"
        style={{ width: "22%", marginBottom: "1rem" }}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        onClick={(e) => e.target.showPicker && e.target.showPicker()}
      />
      <Autocomplete
        id="controlled-demo"
        options={medicos}
        getOptionLabel={(option) => option.nombre}
        value={find(medicos, (opt) => opt.idUsuario == idMedico) || null}
        onChange={(event, newValue) => {
          if (newValue != null) {
            onChangeCita(newValue.idUsuario, "idMedico");
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Médico" variant="outlined" error={false} />
        )}
        style={{ width: "100%", marginBottom: "1rem" }}
        size="small"
      />
      <TextField
        value={observaciones}
        onChange={(event) => {
          onChangeCita(event.target.value, "observaciones");
        }}
        label={"Observaciones"}
        variant="outlined"
        style={{ width: "100%", marginBottom: "1.5rem" }}
        multiline
        rows={5}
        size="small"
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
      />
    </>
  );
}

export default formCita;
